import React, { useState, useEffect } from "react";
import {
  Typography,
  FormControl,
  FormControlLabel,
  TextField,
  InputLabel,
  Input,
} from "@material-ui/core";
import ActionButton from "../../components/ActionButton.js";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import PropertyNames from "../../PropertyNames.js";
import { useSelector, useDispatch } from "react-redux";
import { setApplicationProperties } from "../../redux/actions/universalActions.js";
import "filepond/dist/filepond.min.css";
import axios from "../../AxiosClient.js";
import FormHelperText from "@material-ui/core/FormHelperText";
import { apiCompatibilityParams } from "pdfjs-dist";

var fs = require("fs");

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: 15,
    display: "flex",
  },
  container: {
    height: "100%",
    width: "100%",
  },
  flexContainer: {
    display: "flex",
  },
}));

function ApiSettings() {
  const [saving, setSaving] = useState(false);
  const properties = useSelector((state) => {
    return { ...state.setting.applicationProperties };
  });
  const classes = useStyles();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [updatedProperties, setUpdatedProperties] = useState([]);

  const handleInputChange = (propertyKey) => (e) => {
    updateProperties(propertyKey, e.target.value);
  };

  const updateProperties = (propertyKey, propertyValue) => {
    if (updatedProperties.indexOf(propertyKey) === -1) {
      setUpdatedProperties([...updatedProperties, propertyKey]);
    }
    dispatch(
      setApplicationProperties({
        ...properties,
        [propertyKey]: propertyValue,
      })
    );
  };

  const save = () => {
    setSaving(true);
    let updated = {};
    // so we only patch the changed props and not everything...
    for (const key of updatedProperties) {
      updated[key] = properties[key];
    }
    axios
      .patch("/application-property/", {
        ...updated,
      })
      .then(() => {
        enqueueSnackbar(t("properties_updated_snackbar"), {
          variant: "success",
        });
        let api = `https://${window.location.hostname}:8081/csp-frame`;
        if (!process.env.NODE_ENV || process.env.NODE_ENV === "production") {
          api = `${window.location.protocol}//${window.location.hostname}${
            window.location.port ? ":" + window.location.port : ""
          }/csp-frame`;
        }
        // axios
        // .post(api, {
        //   ...updated,
        // })
        console.log(updated)
        fetch(api, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updated),
        }).catch(() => {
          this.props.enqueueSnackbar("Error saving frame ancestor info", {
            variant: "error",
          });
        });
        setSaving(false);
      })
      .catch((err) => {
        enqueueSnackbar(t("properties_updated_error_snackbar"), {
          variant: "error",
        });
        setSaving(false);
      });
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography variant="h5" style={{ marginRight: 10 }}>
          {t("api_settings_header")}
        </Typography>
        <ActionButton
          variant="contained"
          color="primary"
          onClick={save}
          loading={saving}
        >
          {t("global_save")}
        </ActionButton>
      </div>
      <FormControl fullWidth>
        <InputLabel htmlFor="frameancestor-input">{t("app_api_settings")}</InputLabel>
        <Input 
          id="frameancestor-input" 
          aria-describedby="helper-text" 
          value={properties[PropertyNames.FRAME_ANCESTOR]}
          onChange={handleInputChange(PropertyNames.FRAME_ANCESTOR)}/>
        <FormHelperText id="helper-text">{t("app_api_settings_helper_text")}</FormHelperText>
      </FormControl>
    </div>
  );
}

export default ApiSettings;
